import type { MarqueeProps } from '@time-line/components/common';
import { Marquee } from '@time-line/components/common';
import type { ReviewsCarousel } from 'types/cms/blocks';

import { RichReviewItem } from './RichReviewItem';

interface RichReviewsMarqueeProps extends MarqueeProps {
  reviews: ReviewsCarousel['reviews'];
  showPackagingThumbnail?: boolean;
}

export function RichReviewsMarquee({
  reviews,
  showPackagingThumbnail,
  ...props
}: RichReviewsMarqueeProps) {
  return (
    <Marquee className="rich-reviews-marquee" speed={40} {...props}>
      {reviews.map((review, i) => (
        <RichReviewItem
          key={i}
          review={review}
          showPackagingThumbnail={showPackagingThumbnail}
        />
      ))}
    </Marquee>
  );
}
